import i18n from '@/locale';
import statusCode from '@/assets/constant/statusCode';
import m_progress from '../../../node_modules/tabulator-tables/src/js/modules/Format/defaults/formatters/progress';

export function genHeaderTooltip(){
  return (e, p_column) => {
    let ret_div = document.createElement('div');
    ret_div.style.color = '#FFF';
    ret_div.style['font-size'] = '14px';
    ret_div.style.padding = '6px 8px';
    ret_div.style.borderRadius = '4px';
    ret_div.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.3)';
    ret_div.style.backgroundColor = 'rgba(33, 33, 33, 0.9)';
    ret_div.style.maxWidth = '250px';
    ret_div.style.lineHeight = '1.4';
    ret_div.innerText = p_column.getDefinition().field_desc;
    return ret_div;
  };
}

export function genTooltip(tooltip_fields){
  return (e, p_cell) => {
    let ret_div = document.createElement('div');
    ret_div.style.color = '#FFF';
    ret_div.style['font-size'] = '14px';
    ret_div.style.padding = '8px';
    ret_div.style.borderRadius = '4px';
    ret_div.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.3)';
    ret_div.style.backgroundColor = 'rgba(33, 33, 33, 0.9)';
    ret_div.style.minWidth = '200px';

    tooltip_fields.forEach((em_i, index) => {
      let cell_value = p_cell.getRow().getCell(em_i).getValue();

      let child_div = document.createElement('div');
      child_div.style.display = 'flex';
      child_div.style.justifyContent = 'space-between';
      child_div.style.width = '100%';
      child_div.style.padding = '4px 0';

      // 添加分隔線，除了第一項
      if (index > 0) {
        child_div.style.borderTop = '1px solid rgba(255, 255, 255, 0.1)';
        child_div.style.marginTop = '2px';
        child_div.style.paddingTop = '6px';
      }

      let title = document.createElement('span');
      title.textContent = `${i18n.tfd(em_i)}:`;
      title.style['padding-right'] = '10px';
      title.style.fontWeight = 'bold';
      // title.style.color = '#8CCDFF';
      child_div.appendChild(title);

      let content = document.createElement('span');
      content.textContent = g_number_2_text(cell_value);
      content.style.fontWeight = '500';
      child_div.appendChild(content);

      ret_div.appendChild(child_div);
    });
    return ret_div;
  };
}

// 預設寬度常數（對應 desktop_mixin 中的值）
const DEFAULT_WIDTH_SHORT = 120;
const DEFAULT_WIDTH_TINY = 90;

// 輔助函數：生成總計欄位選項
export function genOptionsTotal(field, options = {}) {
  return {
    field: `${field}|total`,
    width: options.width || DEFAULT_WIDTH_SHORT,
    formatter: 'progress',
    ...(options.field_db_sort !== undefined && { field_db_sort: options.field_db_sort }),
    ...options.extra,
  };
}

// 輔助函數：生成每日平均欄位選項
export function genOptionsPday(field, options = {}) {
  return {
    field: `${field}|pday`,
    width: options.width || DEFAULT_WIDTH_SHORT,
    formatter: 'progress',
    // headerSort: false,
    ...options.extra,
  };
}

// 輔助函數：生成成長率欄位選項
export function genOptionsGrowth(field, suffix = 'gr_rate', options = {}) {
  return {
    field: `${field}|${suffix}`,
    width: options.width || DEFAULT_WIDTH_TINY,
    formatter: 'percent',
    title: i18n.tfd(`|${suffix}`),
    ...options.extra,
  };
}

// 輔助函數：生成排名欄位選項（query_data 系列欄名：<metric>_rank，名次差 <metric>_rank|gr_amt 由前端配對兩期算出）
export function genOptionsRank(field, options = {}) {
  return {
    field: `${field}_rank`,
    field_gr_amt: `${field}_rank|gr_amt`,
    width: options.width || DEFAULT_WIDTH_TINY,
    formatter: 'ranking',
    headerSortStartingDir: 'asc',
    title: i18n.tfd('|rank'),
    ...options.extra,
  };
}

// 舊 /ocms/reporting 系列欄名（<metric>|rank，後端算好名次差）；只剩 list_game_theme_by_page 在用，game_retention 遷到 query_data 後刪除
export function genOptionsRankLegacy(field, options = {}) {
  return {
    ...genOptionsRank(field, options),
    field: `${field}|rank`,
    field_gr_amt: `${field}|rank|gr_amt`,
  };
}

export class TabuHandlerBase{

  constructor(){
    this.clear();
    this._ref = null;
  }

  clear(){
    this._aqt = undefined;
    this._dataset = [];
    this._option = {};
    return this;
  }


  mergeOption(p_val){
    _.merge(this._option, p_val);
    return this;
  }

  setDataset(p_val){
    this._dataset = p_val;
    this._aqt = g_aq.from(this._dataset);
    return this;
  }

  // 设置对应的 VueTabulator 引用
  setRef(ref){
    this._ref = ref;
    return this;
  }

  getInstance(){
    return this._ref.getInstance();
  }

  // 重置 Tabulator 实例
  resetTabulator(){
    this.getInstance().destroy();
    return this;
  }

  async setSortAfterTableBuilt(vueInstance, sort_params){
    await vueInstance.$nextTick();

    const tableInstance = this.getInstance();
    tableInstance.on("tableBuilt", async() => {
      tableInstance.setSort(sort_params);
      tableInstance.off("tableBuilt");
    });
    return this;
  }

  addColumnGroup(column_group_idx, title){
    this._option.columns ??= [];
    this._option.columns.push({column_group_idx, title, columns: [], headerHozAlign: 'center'});
    return this;
  }

  addColumnToGroup(column_group_idx, column_option){
    this._option.columns ??= [];

    let found_column = this._option.columns.find(el_i => el_i.column_group_idx == column_group_idx);
    if(undefined == found_column)
      return this;

    found_column.columns ??= [];
    const new_option = this.genColumnOption(column_option);
    if(undefined != new_option)
      found_column.columns.push(new_option);
    return this;
  }

  addColumn(column_option){
    this._option.columns ??= [];
    const new_option = this.genColumnOption(column_option);
    if(undefined != new_option)
      this._option.columns.push(new_option);
    return this;
  }

  addColumnAt(idx, column_option){
    this._option.columns ??= [];
    const new_option = this.genColumnOption(column_option);
    if(undefined != new_option)
      this._option.columns.splice(idx, 0, new_option);
    return this;
  }

  genColumnOption(column_option){
    const valueRange = this._getValueRange(column_option);
    if (!valueRange) {
      return undefined;
    }

    const {value_min, value_max} = valueRange;

    if(undefined == column_option.title)
      column_option.title = i18n.tfd(column_option.field);

    let ret_option = {
      headerHozAlign: 'center',
      hozAlign: 'center',
      resizable: 'header',
    };

    this._applyAutoColors(column_option);

    // 應用格式化選項
    this._applyFormatters(ret_option, column_option, value_min, value_max);

    // 處理 cellClick 事件
    if(column_option.cellClick){
      _.merge(ret_option, {
        cellClick: column_option.cellClick,
        formatter: p_cell => `<span style='color: deepskyblue; font-weight: bold; text-decoration: underline;'>${p_cell.getValue()}</span>`,
      });
    }

    this._genFieldDescriptionTooltip(column_option);

    if(column_option?.field_desc?.length > 0)
      _.merge(ret_option, {headerTooltip: genHeaderTooltip()});

    if(column_option?.tooltip_fields?.length > 0)
      _.merge(ret_option, {tooltip: genTooltip(column_option.tooltip_fields)});

    // 設定可排序欄位的預設排序方向為 desc
    this._setDefaultSortDirection(column_option);

    return _.merge(ret_option, column_option);
  }

  // 取得數值範圍的方法，子類可覆寫
  _getValueRange(column_option) {
    if(!this._aqt || -1 == this._aqt.columnIndex(column_option.field))
      return null;

    let {value_min, value_max} = this._aqt
      .rollup({
        'value_min': g_aq.op.min(column_option.field),
        'value_max': g_aq.op.max(column_option.field),
      })
      .object()

    if(null == value_max || undefined == value_max)
      return null;

    return {value_min, value_max};
  }

  // 設定預設排序方向
  _setDefaultSortDirection(column_option) {
    if( !column_option?.headerSortStartingDir){
      column_option.headerSortStartingDir = "desc";
    }
  }

  /**
   * 自動套用欄位顏色
   * 從 metrics_definition 定義來源取得顏色配置並套用到 column_option
   * 注意：如果已手動指定顏色（formatterParams.color），則優先使用手動指定
   * @param {object} column_option - 欄位選項
   * @private
   */
  _applyAutoColors(column_option) {
    if (!column_option.field) return;

    // 如果已經手動指定顏色，則不覆蓋
    if (column_option?.formatterParams?.color) return;

    const field_colors = i18n.get_field_colors(column_option.field);
    if (field_colors) {
      column_option.field_color = field_colors.value;
      column_option.field_color_key = field_colors.key;
    }
  }

  /**
   * 自動生成欄位描述 tooltip
   * 優先級：手動指定 field_desc > 自動取得 tfd_desc() > 無 tooltip
   * @param {object} column_option - 欄位選項
   * @private
   */
  _genFieldDescriptionTooltip(column_option) {
    if (!column_option.field) return;

    // 如果已經手動指定 field_desc，則不覆蓋
    if (column_option?.field_desc?.length > 0) return;

    // 嘗試從 metrics_definition 定義來源自動取得描述
    const auto_desc = i18n.tfd_desc(column_option.field);
    if (auto_desc && auto_desc.length > 0) {
      column_option.field_desc = auto_desc;
    }
  }

  // 格式化方法
  _applyFormatters(ret_option, column_option, value_min, value_max) {
    if('progress' == column_option?.formatter){
      // 準備 formatterParams，如果有自動色碼則使用，否則使用手動指定的顏色
      const formatter_params = {
        min: value_min,
        max: value_max,
        legendAlign: 'right',
        legendColor: p_value => p_value >= 0 ? '#FFF' : 'tomato',
      };

      // 如果有自動取得的顏色，則套用（優先於手動指定）
      if (column_option?.field_color) {
        formatter_params.color = [column_option.field_color];
      }

      _.merge(ret_option, {
        headerHozAlign: 'center',
        hozAlign: 'right',
        formatterParams: formatter_params,
      });

      column_option.formatter = function(cell, formatterParams){
        let ratio_value = '';
        if(column_option?.field_ratio){
          ratio_value = cell.getRow().getCell(column_option.field_ratio).getValue() || 0;
          ratio_value = g_number_2_text(ratio_value, {is_percent: true, fraction_digits: 2});
          ratio_value = ` (${ratio_value})`;
        }

        const cell_value = parseFloat(cell.getValue() || 0);
        const number_text = g_number_2_text(cell_value, column_option?.number_format);
        const display_text = `${number_text}${ratio_value}`;

        // 文字顏色（沿用原本 legendColor 規則）
        let legend_color = '#FFF';
        if(typeof formatterParams.legendColor === 'function'){
          legend_color = formatterParams.legendColor(cell_value);
        }else if(typeof formatterParams.legendColor === 'string'){
          legend_color = formatterParams.legendColor;
        }

        // 取得 bar 顏色
        let bar_color = '#2DC214';
        if(Array.isArray(formatterParams.color) && formatterParams.color.length > 0){
          bar_color = formatterParams.color[0];
        }else if(typeof formatterParams.color === 'string'){
          bar_color = formatterParams.color;
        }

        // 動態計算中線位置：以 0 為基準，根據資料的 min/max 決定 0 在整個區間中的位置
        const min_val = typeof formatterParams.min === 'number' ? formatterParams.min : 0;
        const max_val = typeof formatterParams.max === 'number' ? formatterParams.max : 0;
        const abs_min = Math.abs(min_val);
        const abs_max = Math.abs(max_val);

        const has_positive_and_negative = (min_val < 0 && max_val > 0);

        let width_percent = 0;
        let bar_position_style = '';

        if(has_positive_and_negative){
          // 雙向模式：同一欄位同時有正負數，以 0 為中線，左右依 max / |min| 比例切分
          const total_abs = abs_min + abs_max || 1;
          const center_percent = (abs_max / total_abs) * 100; // 左側代表正數

          if(cell_value >= 0){
            // 正數：從中線往「左」延伸（左側區域寬度 = center_percent）
            const base = center_percent;
            width_percent = Math.min(Math.abs(cell_value) / abs_max * base, base);
            bar_position_style = `right:${100 - center_percent}%;`;
          }else{
            // 負數：從中線往「右」延伸（右側區域寬度 = 100 - center_percent）
            const base = 100 - center_percent;
            width_percent = Math.min(Math.abs(cell_value) / abs_min * base, base);
            bar_position_style = `left:${center_percent}%;`;
          }
        }else{
          // 單向模式：全正或全負
          const range_abs_max = Math.max(abs_min, abs_max, 1);
          width_percent = Math.min(Math.abs(cell_value) / range_abs_max * 100, 100);

          if(max_val > 0){
            // 全正：單向，從右往左
            bar_position_style = 'right:0;';
          }else{
            // 全負：單向，從左往右
            bar_position_style = 'left:0;';
          }
        }

        return `
          <div style="position:relative;width:100%;height:100%;">
            <div style="position:absolute;top:0;bottom:0;${bar_position_style}width:${width_percent}%;background-color:${bar_color};"></div>
            <div style="position:absolute;top:0;left:0;width:100%;text-align:right;color:${legend_color};">
              <span style="font-weight:bold;">${display_text}</span>
            </div>
          </div>
        `;
      };
    }

    if('ranking' == column_option?.formatter){
      column_option.formatter = function(cell, formatterParams, onRendered){
        const rank_value = cell.getValue();
        const diff_value = cell.getRow().getCell(column_option.field_gr_amt).getValue() || 0;
        const [cell_class, cell_style] = (() => {
          if(diff_value == 0) return ['fa fa-minus', ''];
          if(diff_value < 0) return ['fa fa-arrow-up', 'color: limegreen;'];
          if(diff_value > 0) return ['fa fa-arrow-down', 'color: tomato;'];
        })();
        const cell_html = (diff_value == 0 ? '' : `<span style='${cell_style}'>${Math.abs(diff_value)}</span>`);
        return `${rank_value} <i class='${cell_class}' style='${cell_style}'></i>${cell_html}`;
      }
    }

    if('percent' == column_option?.formatter){
      column_option.formatter = function(cell, formatterParams, onRendered){
        const cell_value = cell.getValue() || 0;
        const is_reverse_metric = column_option?.is_reverse_metric ?? false;
        return `<span style='float:right; font-weight: bold; color: ${cell_value >= 0 ^ is_reverse_metric ? 'limegreen' : 'tomato'};'>${g_number_2_text(cell_value, {is_percent: true, fraction_digits: 2})}</span>`;
      }
    }

    if('number' == column_option?.formatter){
      column_option.hozAlign = 'right';
      column_option.formatter = 'money';
      column_option.formatterParams = {precision: 0};
    }

    if('chips' == column_option?.formatter){
      column_option.formatter = function(cell, formatterParams, onRendered){
        const chip_list = cell.getValue() || [];
        if(!Array.isArray(chip_list) || chip_list.length === 0) return '';

        const {field_chip_name} = column_option;
        const {field_chip_color} = column_option;

        return chip_list.map(em_i => {
          const name = em_i[field_chip_name] || '';
          const color = em_i[field_chip_color] || '#cccccc';
          return `<span style="display: inline-block; padding: 1px 8px; margin: 2px; border-radius: 8px; border: 2px solid ${color}; background-color: black; color: white; font-size: 13px;">${name}</span>`;
        }).join('');
      }
    }
  }
}

export class TabuHandlerSimple extends TabuHandlerBase{

  initOption(){
    return this
    .clear()
    .mergeOption({
      // autoColumns: true,
      columnHeaderVertAlign: 'bottom',
      // layout: 'fitColumns',
      layout: 'fitDataFill',
      pagination: 'local',
      paginationSize: 20,
      // movableColumns: true,
      tooltipGenerationMode: 'hover',
      layoutColumnsOnNewData: true,
    });
  }
}

export class TabuHandlerRemote extends TabuHandlerBase{

  initOption(vueInstance, req_func, func_params){
    const options = {
      columnHeaderVertAlign: 'bottom',
      layout: 'fitDataFill',
      pagination: 'remote',
      paginationMode: 'remote',
      paginationSize: 50,
      paginationSizeSelector: [20, 50, 100, 200],
      paginationCounter: function(pageSize, currentRow, currentPage, totalRows) {
        const start = ((currentPage - 1) * pageSize) + 1;
        const end = Math.min(start + pageSize - 1, totalRows || 0);
        const safeTotal = totalRows || 0;
        return `${i18n.t('common.pagination.display')} ${start}-${end} ${i18n.t('common.pagination.to')} ${safeTotal.toLocaleString()}  (${i18n.t('common.pagination.page')} ${currentPage})`;
      },
      tooltipGenerationMode: 'hover',
      layoutColumnsOnNewData: true,
      ajaxSorting: true,
      sortMode: 'remote',
      ajaxURL: '/api/placeholder', // Tabulator 在遠端模式下需要 ajaxURL
      ajaxRequestFunc: this.genAjaxRequestFunc(req_func, func_params),
    };

    this._last_cache_table_job = undefined;
    this.clear().mergeOption(options).loadFirstPage(vueInstance);
    return this;
  }

  async loadFirstPage(vueInstance){
    await vueInstance.$nextTick();

    const tableInstance = this.getInstance();
    tableInstance.on("tableBuilt", async() => {
      tableInstance.setPage(1);
    });
    return this;
  }

  genAjaxRequestFunc(req_func, func_params){
    return async(url, config, params) => {
      const page_num = params.page || 1;
      const page_size = params.size || 50;
      const sort_params = params.sort?.[0] || func_params?.init_sort_params;
      const sort_info = this.parseSortParams(sort_params);

      func_params.req_params = {
        ...func_params.req_params,
        sort_info,
        pagination: {
          offset: (page_num - 1) * page_size,
          limit: page_size,
        },
      };

      if(!_.isEqual(this._last_sort_info, sort_info))
        this._last_cache_table_job = undefined;

      func_params.req_params.cache_table_job = this._last_cache_table_job;
      this._last_sort_info = sort_info;

      try {
        const result = await req_func(func_params);
        const total_count = result?.cache_table_info.cache_table_total_rows || 0;
        const calculated_last_page = total_count === 0 ? 1 : Math.ceil(total_count / page_size);

        this._last_cache_table_job = result?.cache_table_job;

        if (result.rds_status === statusCode.STATUS_OK) {
          // 確保資料結構正確
          let {aqt_table} = result;
          let rds_table = [];
          if (aqt_table) {
            const{field, dir} = sort_params;
            if(dir == 'asc') aqt_table = aqt_table.orderby(field);
            if(dir == 'desc') aqt_table = aqt_table.orderby(g_aq.desc(field));
            rds_table = aqt_table.objects();
          }

          const response_data = {
            last_page: calculated_last_page,
            last_row: total_count,
            data: rds_table,
          };

          // 更新 progress bar 的最大值
          if (rds_table && rds_table.length > 0)
            this.updateProgressBarMaxValues(rds_table);

          return response_data;
        } else {
          return {
            last_page: calculated_last_page,
            last_row: total_count,
            data: [],
          };
        }
      } catch (error) {
        return {
          last_page: 1,
          last_row: 0,
          data: [],
        };
      }
    };
  }

  // 在資料載入後更新所有 progress 欄位的最大值
  updateProgressBarMaxValues(tableData) {
    if (!tableData || tableData.length === 0) {
      return;
    }

    const tableInstance = this.getInstance();
    const progressFields = [];

    tableInstance.getColumns().forEach(column => {
      const columnDef = column.getDefinition();
      // 檢查是否為 progress 欄位：有 formatterParams 且包含 max、min 或 legendAlign 等 progress 特有屬性
      if (columnDef.formatterParams &&
          (columnDef.formatterParams.hasOwnProperty('max') ||
           columnDef.formatterParams.hasOwnProperty('legendAlign'))) {
        const field = column.getField();
        progressFields.push(field);
      }
    });

    if (progressFields.length === 0) {
      return;
    }

    // 為每個 progress 欄位分別計算其最大值
    progressFields.forEach(field => {
      const values = tableData.map(row => parseFloat(row[field]) || 0).filter(v => !isNaN(v));
      if (values.length > 0) {
        const fieldMax = Math.max(...values);
        const fieldMin = Math.min(...values);

        // 更新該欄位的所有 column 的 formatterParams
        tableInstance.getColumns().forEach(column => {
          if (column.getField() === field) {
            const columnDef = column.getDefinition();
            if (columnDef.formatterParams) {
              columnDef.formatterParams.max = fieldMax;
              columnDef.formatterParams.min = fieldMin;
            }
          }
        });
      }
    });

    // 觸發重新渲染
    tableInstance.redraw(true);
  }

  parseSortParams(sort_params) {
    if(!sort_params)
      return undefined;

    const find_column_recursively = (columns, field) => {
      for(const column of columns){
        if(column.field === field)
          return column;

        if(!column.columns)
          continue;

        const found_column = find_column_recursively(column.columns, field);
        if(found_column)
          return found_column;
      }
    }
    const sort_column = find_column_recursively(this._option.columns, sort_params.field);
    return {
      sort_field: sort_column?.field_db_sort || sort_params.field,
      sort_dir: sort_params.dir,
    };
  }

  // 覆寫父類方法：遠端分頁模式使用固定範圍
  _getValueRange(column_option) {
    return {value_min: 0, value_max: 100};
  }
}
